import { render } from "./Build.vue?vue&type=template&id=5cdfdbbc"
import script from "./Build.vue?vue&type=script&lang=js"
export * from "./Build.vue?vue&type=script&lang=js"

import "./Build.vue?vue&type=style&index=0&id=5cdfdbbc&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.31.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__